/* eslint-disable */
import STATUS_CODE from 'Utilities/constant/statusCode';

export default {
  install(Vue) {
    Vue.prototype.$setValidationErrors = function (statusCode, errorResponse) {
      // only allow this function to be run if the validator exists
      if (!Object.prototype.hasOwnProperty.call(this, '$validator')) {
        return;
      }

      if (statusCode !== STATUS_CODE.UNPROCESSABLE_ENTITY) {
        return;
      }

      // clear errors
      this.$validator.errors.clear();

      // check if errors exist
      if (!Object.prototype.hasOwnProperty.call(errorResponse, 'errors')) {
        return;
      }

      const errorFields = Object.keys(errorResponse.errors);

      // insert laravel errors
      for (let i = 0; i < errorFields.length; i++) {
        const field = errorFields[i];

        const errorString = errorResponse.errors[field].join(', ');
        this.$validator.errors.add({ 'field': field, 'msg': errorString });
      }
    };
  },
};
